import { useState, useParams, ToastContainer, BiRupee } from '../../common/common';
import useNavigation from '../../common/useNavigation';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import MidPlans from '../../middleware/plans/MidPlans';
import { sidebarLogo } from '../../common/common';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { FaMinus, FaPlus, FaUser } from 'react-icons/fa';
import { useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';


const Cart = () => {

    const { type, cur, id } = useParams();

    const [issidebarOpen, setIssidebarOpen] = useState(true);

    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, setisLoading, Mainplans, subUser, userPlanDetails } = MidPlans(type);
    const { navigatePlans, } = useNavigation();

    const [userModalOpen, setUserModalOpen] = useState(false);

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var EmailAddress = users[0]['EmailAddress'];
        var ActiveUser = users[0]["Status"];


    }

    const [planFilter, setPlanFilter] = useState([]);

    const [userCounts, setUserCounst] = useState(0)

    // console.log({ userPlanDetails: userPlanDetails });


    const planPricePerMonth = cur === "true"
        ? planFilter[0]?.inr_price_monthly
        : planFilter[0]?.price_monthly;


    const userPricePerMonth = cur === "false" ? 19 : 1000;
    const orderPricePerOrder = cur === "false" ? 0.05 : 2.5;

    const [userss, setUsers] = useState(0);
    const [orders, setOrders] = useState(0);

    // Users increment/decrement
    const handleUserIncrease = () => setUsers((prev) => prev + 1);
    const handleUserDecrease = () => setUsers((prev) => (prev > 0 ? prev - 1 : 0));

    // Orders increment/decrement (in multiples of 100)
    const handleOrderIncrease = () => setOrders((prev) => prev + 100);
    const handleOrderDecrease = () => setOrders((prev) => (prev >= 100 ? prev - 100 : 0));

    // Calculations
    const usersTotalPerMonth = userss * userPricePerMonth;
    const usersTotalYearly = usersTotalPerMonth * 12;

    const ordersTotal = orders * orderPricePerOrder;

    const planTotalYearly = planPricePerMonth * 12;
    const subTotal = planTotalYearly + usersTotalYearly + ordersTotal;
    const gst = subTotal * 0.18;
    const grandTotal = subTotal + gst;

    useEffect(() => {
        const fetchPlan = () => {
            if (Mainplans && Mainplans.length > 0) {
                const filteredPlan = Mainplans.filter((plan) => plan.unique_id === id);
                if (filteredPlan.length > 0) {
                    setPlanFilter(filteredPlan);
                }
                else {
                    navigatePlans(type)
                }

            }
        };

        fetchPlan();
    }, [Mainplans, id]);


    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }


    const handleCheckUsers = () => {

        const select_plan_user = planFilter[0].plan_user;
        const total_user_calculate = select_plan_user + userss;
        
        if (userPlanDetails[0]["plan_id"] === 0) {
            displayRazorpay();
        }
        else {
            if (total_user_calculate >= subUser.length) {
                displayRazorpay();
            }
            else {
                setUserCounst(total_user_calculate)
                setUserModalOpen(true)
            }
        }
    }


    async function displayRazorpay() {
        if (!id) {
            navigatePlans(type)
        }

        // alert('Payment Gatway call');
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        if (!res) {
            // alert("Razorpay SDK failed to load. Are you online?");
            return;
        }

        let total_amount = 0;

        if (cur === "true") {
            total_amount = grandTotal * 100
        }
        else {
            total_amount = grandTotal
        }

        // creating a new order
        const result = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Payment`, { plan_name: planFilter.name, cart_ammount: total_amount, plan_currency: cur === "true" ? 'INR' : 'USD' }, { withCredentials: true });
        // console.log({ result: result });
        if (!result) {
            // alert("Server error. Are you online?");
            return;
        }


        const options = {
            key: "rzp_test_HHHXi6bhZ0bIvf", // This is Api key. you will get it from razorpay dashboard > account and settings > API keys
            amount: parseInt(grandTotal * 100),
            currency: "INR", // your 3 letter currency code
            name: username, // project or transaction name
            description: "Test Transaction",
            order_id: result.data.order.id,
            image: { sidebarLogo }, // your project logo
            handler: function (response) {
                // console.log("response", response);
                orderPlace(response, planFilter[0], grandTotal, 1); // after payment completes on stripe this function will be called and you can do your stuff
            },
            prefill: {
                name: username,
                email: EmailAddress,
                contact: '852369741',
            },
            notes: {
                address: "India",
            },
            theme: {
                color: "#158993",
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    }

    const orderPlace = async (response, plan, total, check) => {
        // console.log(response);
        // console.log(plan);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/purchasePlan`, { response, plan, user_count: userss, order_count: orders, grandTotal: total, check }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        StopLoading(setisLoading);
                        navigatePlans(type)
                        // console.log(res.data.data);
                        showToast("success ", 'success');

                    }
                    else {
                        // console.log('error');
                        StopLoading(setisLoading);
                        showToast("Failed to get purchasePlan, please try again later ", 'error');
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        console.error('Server responded with a status:', err.response.status);
                        console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        console.error('No response received:', err.request);
                    } else {
                        console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to get purchasePlan, please try again later ", 'error');
        }
    }

    const [selectedUsers, setSelectedUsers] = useState([]);

    // Checkbox toggle
    const handleCheckboxChange = (user) => {
        const isSelected = selectedUsers.some((u) => u.id === user.id);

        if (isSelected) {
            // Pehle se selected hai to simply remove kar dena
            setSelectedUsers(selectedUsers.filter((u) => u.id !== user.id));
        } else {
            // Naya select karte waqt check karo limit cross na ho
            if (selectedUsers.length < userCounts) {
                setSelectedUsers([
                    ...selectedUsers,
                    {
                        id: user.id,
                        user_unique_id: user.user_unique_id,
                        parent_user_id: user.parent_user_id
                    }
                ]);
            } else {
                showToast("Cannot select more than allowed users", "error");
            }
        }
    };

    const handleInActiveUser = async (e) => {
        e.preventDefault();

        try {
            const response = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/planInUserInActive`,
                { users: selectedUsers },
                { withCredentials: true }
            );

            if (response.data.success === 1) {
                displayRazorpay();
                showToast(response.data.message, 'success');
                setUserModalOpen(false);
            } else {
                showToast(response.data.message, 'warning'); // success nahi to warning show karo
                setUserModalOpen(false);
            }

        } catch (err) {
            showToast(err.response?.data?.message || "Something Went Wrong !!!", 'error');
        }
    };

    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />

                <div className="grid grid-cols-12">
                    <div className="col-span-12">
                        <div className="rounded-xl shadow-lg bg-white">
                            <div className='p-3'>
                                <div className='flex flex-row justify-between items-center my-4'>
                                    <h5 className=" capitalize text-xl font-bold mb-0">Plans & Pricing </h5>
                                </div>
                                {/* Content */}
                                <div className="p-6 w-full border-t-2 border-solid border-t-gray-300">
                                    <div className="w-full">
                                        {/* Selected Plan */}
                                        <div className="border-b pb-4 mb-6">
                                            {/* <h2 className="text-lg font-semibold text-gray-800">{planFilter[0]?.plan_user}</h2> */}
                                            <p className="text-gray-500 text-sm mb-2">
                                                {`1 Seller, ${planFilter[0]?.plan_user} User, ${planFilter[0]?.plan_orders}, per Month ${cur === "false" ? ` $ ` + planFilter[0]?.price_monthly : planFilter[0]?.inr_price_monthly
                                                    }, total ${cur === "false" ? ` $ ` + planFilter[0]?.price_monthly * 12 : planFilter[0]?.inr_price_monthly * 12
                                                    }`}

                                            </p>
                                            <div className="flex justify-between text-gray-700 font-medium bg-gray-100 p-3 rounded-lg">
                                                <span>Validity: 12 Months</span>
                                                <span>Per Month: <span className="font-bold">{cur === "false" ? "$" + planPricePerMonth : "₹" + planPricePerMonth}</span></span>
                                                <span>
                                                    Total:
                                                    <span className="font-bold">
                                                        {planPricePerMonth != null
                                                            ? (cur === "false"
                                                                ? "$" + Number(planPricePerMonth).toFixed(2)
                                                                : "₹" + Number(planPricePerMonth).toFixed(2)
                                                            )
                                                            : "N/A"}
                                                    </span>
                                                </span>

                                            </div>
                                        </div>

                                        {/* Additional Users */}
                                        <div className="border-b pb-4 mb-6">
                                            <div className="flex justify-between items-center mb-2">
                                                <span className="font-semibold text-gray-800 text-lg">Additional Users ({userss})</span>
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={handleUserDecrease}
                                                        className="bg-gray-200 hover:bg-gray-300 p-2 rounded-full shadow"
                                                    >
                                                        <FaMinus />
                                                    </button>
                                                    <span className="text-lg font-bold w-8 text-center">{userss}</span>
                                                    <button
                                                        onClick={handleUserIncrease}
                                                        className="bg-pink-500 hover:bg-pink-600 text-white p-2 rounded-full shadow"
                                                    >
                                                        <FaPlus />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="flex justify-between text-gray-700 bg-gray-100 p-3 rounded-lg">
                                                <span>Validity: 12 Months</span>
                                                <span>Per User Per Month: <span className="font-bold">{cur === "false" ? "$" + userPricePerMonth : "₹" + userPricePerMonth}</span></span>
                                                <span>
                                                    Total:
                                                    <span className="font-bold">
                                                        {usersTotalYearly != null
                                                            ? (cur === "false"
                                                                ? "$" + Number(usersTotalYearly).toFixed(2)
                                                                : "₹" + Number(usersTotalYearly).toFixed(2)
                                                            )
                                                            : "N/A"}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>

                                        {/* Additional Orders */}
                                        <div className="border-b pb-4 mb-6">
                                            <div className="flex justify-between items-center mb-2">
                                                <span className="font-semibold text-gray-800 text-lg">Additional Orders ({orders})</span>
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={handleOrderDecrease}
                                                        className="bg-gray-200 hover:bg-gray-300 p-2 rounded-full shadow"
                                                    >
                                                        <FaMinus />
                                                    </button>
                                                    <span className="text-lg font-bold w-12 text-center">{orders}</span>
                                                    <button
                                                        onClick={handleOrderIncrease}
                                                        className="bg-pink-500 hover:bg-pink-600 text-white p-2 rounded-full shadow"
                                                    >
                                                        <FaPlus />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="flex justify-between text-gray-700 bg-gray-100 p-3 rounded-lg">
                                                <span>Validity: 12 Months</span>
                                                <span>Per Order : <span className="font-bold">{cur === "false" ? "$" + orderPricePerOrder : "₹" + orderPricePerOrder}</span></span>

                                                <span>
                                                    Total:
                                                    <span className="font-bold">
                                                        {ordersTotal != null
                                                            ? (cur === "false"
                                                                ? "$" + Number(ordersTotal).toFixed(2)
                                                                : "₹" + Number(ordersTotal).toFixed(2)
                                                            )
                                                            : "N/A"}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>

                                        {/* Summary */}
                                        <div className="space-y-3 text-gray-800 bg-gray-50 p-4 rounded-lg">
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">Sub-Total</span>
                                                <span>
                                                    <span className="font-semibold">
                                                        {ordersTotal != null
                                                            ? (cur === "false"
                                                                ? "$" + Number(subTotal).toFixed(2)
                                                                : "₹" + Number(subTotal).toFixed(2)
                                                            )
                                                            : "N/A"}
                                                    </span>
                                                </span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span className="text-gray-600">GST (18%)</span>
                                                <span>
                                                    <span className="font-semibold">
                                                        {ordersTotal != null
                                                            ? (cur === "false"
                                                                ? "$" + Number(gst).toFixed(2)
                                                                : "₹" + Number(gst).toFixed(2)
                                                            )
                                                            : "N/A"}
                                                    </span>
                                                </span>
                                            </div>
                                            <div className="flex justify-between font-bold text-xl border-t pt-3">
                                                <span>Total</span>

                                                <span>
                                                    <span className="font-semibold">
                                                        {ordersTotal != null
                                                            ? (cur === "false"
                                                                ? "$" + Number(grandTotal).toFixed(2)
                                                                : "₹" + Number(grandTotal).toFixed(2)
                                                            )
                                                            : "N/A"}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>

                                        <div className='flex justify-end
                                         mt-4'>
                                            <button type="button" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color "
                                                onClick={handleCheckUsers}
                                            >
                                                <span className="relative text-md text-black font-semibold ">Continue to Checkout</span>

                                            </button >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {userModalOpen && (
                    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
                        {/* Modal Box */}
                        <div className="bg-white w-[95%] sm:w-[600px] md:w-[700px] lg:w-[900px] p-6 rounded-2xl shadow-xl relative animate-fadeIn">
                            {/* Close Button */}
                            <button
                                onClick={() => setUserModalOpen(false)}
                                className="absolute top-3 right-3 text-gray-500 hover:text-black transition"
                            >
                                <AiOutlineClose size={22} />
                            </button>

                            {/* Header */}
                            <div className="flex items-center justify-between p-4 mb-5 border-b border-gray-200">
                                <h2 className="text-2xl font-bold text-gray-800">User List</h2>
                                <span className="px-4 py-1 text-sm font-medium text-white bg-blue-500 rounded-full shadow">
                                    {userCounts} Users
                                </span>
                            </div>

                            {/* User List */}

                            {subUser.length > 0 &&
                                <div className="space-y-4 max-h-[55vh] overflow-y-auto p-2">
                                    {subUser?.map((user) => (
                                        <div
                                            key={user.id}
                                            className="flex items-center justify-between p-4 border border-gray-200 rounded-2xl shadow-sm hover:shadow-lg transition-transform duration-300 bg-white hover:-translate-y-1"
                                        >
                                            {/* User Info */}
                                            <div className="flex items-center space-x-4">
                                                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100">
                                                    <FaUser className="text-blue-500 text-xl" />
                                                </div>
                                                <div>
                                                    <h3 className="text-lg font-semibold text-gray-800">
                                                        {user.full_name}
                                                    </h3>
                                                    <p className="text-gray-500 text-sm">{user.email}</p>
                                                    <p className="text-gray-500 text-sm">{user.mobile}</p>
                                                </div>
                                            </div>

                                            {/* Checkbox */}
                                            <input
                                                type="checkbox"
                                                className="w-5 h-5 cursor-pointer accent-blue-500"
                                                onChange={() => handleCheckboxChange(user)}
                                                checked={selectedUsers.some((u) => u.id === user.id)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            }

                            {/* Action Buttons */}
                            <div className="flex justify-between gap-3 mt-6">
                                <button
                                    onClick={() => setUserModalOpen(false)}
                                    className="w-1/2 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 transition"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleInActiveUser}
                                    className="w-1/2 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition"
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                )}



            </div>
            <ToastContainer />
        </div>
    )
}

export default Cart